export const START_SESSION_TITLE = 'Start a session'
export const CHAT_SESSION_SCOPE_TITLE = 'Select session scope for Chat'
export const GENERAL_CONVERSATIONS_HEADING = 'Ask anything across repositories'
export const WORK_IN_REPOSITORY_HEADING = 'Work in a repository'
export const SEARCH_REPOSITORIES_PLACEHOLDER = 'Search repositories...'
